export const REGISTER_FIELD_CHANGE = 'AUTOMATIONS/REGISTER_FIELD_CHANGE';
export const SET_AUTOMATIONS = 'AUTOMATIONS/SET_AUTOMATIONS';
export const CLEAR_AUTOMATIONS = 'AUTOMATIONS/CLEAR_AUTOMATIONS';
export const HANDLE_LOADING = 'AUTOMATIONS/HANDLE_LOADING';
export const SET_AUTOMATIONS_ERRORS = 'AUTOMATIONS/SET_AUTOMATIONS_ERRORS';
export const CLEAR_AUTOMATIONS_ERRORS = 'AUTOMATIONS/CLEAR_AUTOMATIONS_ERRORS';